import React from 'react';
import styled from 'styled-components';
import api from '../services/api';
const instancia = process.env.REACT_APP_INSTANCIA;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.h2`
  margin-top: 0;
  font-size: 18px;
  color: #333;
  margin-bottom: 16px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const InputGroup = styled.div`
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const SaveButton = styled(Button)`
  background-color: #6c5ce7;
  color: white;
`;

const CancelButton = styled(Button)`
  background-color: #ccc;
  color: #333;
`;

const FornecedorSection = styled.div`
  margin-top: 16px;
`;

const FornecedorNome = styled.p`
  margin-top: 8px;
  font-weight: bold;
  color: #2ecc71;
`;

const ChequePagarModal = ({ isOpen, onClose, onSave, initialData }) => {

    const [form, setForm] = React.useState({
        banco: '',
        numero: '',
        valor: '',
        emissao: '',
        vencimento: '',
        status: 'PENDENTE',
        observacao: '',
        cpfCnpj: '',
        nomeFornecedor: '',
        codFornecedor: 0,
        cod_cheque: 0,
        codContaCorrente: 0,
        obs: ''
    });

    const [carregandoFornecedor, setCarregandoFornecedor] = React.useState(false);
    const [fornecedores, setFornecedores] = React.useState([]);
    const [fornecedorSelected, setFornecedorSelected] = React.useState(0);
    const [contaCorrente, setContaCorrente] = React.useState([]);
    const [contaSelecionada, setContaSelecionada] = React.useState('');

    React.useEffect(() => {
        handleFornecedores();
        handleContaCorrente();
    });

    React.useEffect(() => {
        if (initialData) {
            const venctoFormatada = initialData.VENCIMENTO.split("T")[0];
            const emissaoFormatada = initialData.EMISSAO.split("T")[0];
            setForm({
                banco: initialData.BANCO || '',
                numero: initialData.NUMERO || '',
                valor: initialData.VALOR || '',
                emissao: emissaoFormatada || '',
                vencimento: venctoFormatada || '',
                status: initialData.STATUS || 'PENDENTE',
                observacao: initialData.OBSERVACOES || '',
                cpfCnpj: initialData.CNPJ_CPF || '',
                nomeFornecedor: initialData.nome || '',
                cod_cheque: initialData.COD_CHEQUE || '',
                codFornecedor: initialData.COD_FORNECEDOR || 0,
                codContaCorrente: initialData.COD_CONTACORRENTE || 0
            });
            setContaSelecionada(initialData.COD_CONTACORRENTE);
            setFornecedorSelected(initialData.COD_FORNECEDOR);
        } else {
            setForm({
                banco: '',
                numero: '',
                valor: '',
                emissao: '',
                vencimento: '',
                status: 'PENDENTE',
                observacao: '',
                cpfCnpj: '',
                nomeFornecedor: '',
                cod_cheque: 0,
                codFornecedor: 0,
                codContaCorrente: 0
            });
        }
    }, [initialData]);

    const handleFornecedores = (async () => {
        try {
            // Aqui você faria a chamada real para a API:
            const response = await api.get(`/fornecedores/${instancia}/TODOS`);

            if (response.data.length > 0) {
                setFornecedores(response.data);
            } else {
                alert('Fornecedores não encontrados');
            }
        } catch (err) {
            alert('Erro ao buscar fornecedores.');
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleBuscarFornecedor = async () => {
        const cpfCnpj = form.cpfCnpj.replace(/\D/g, '');
        if (!cpfCnpj || cpfCnpj.length < 11) {
            alert('Digite um CPF ou CNPJ válido.');
            return;
        }
        setCarregandoFornecedor(true);
        try {
            // Aqui você faria a chamada real para a API:
            const response = await api.get(`/fornecedores/doc/${instancia}/${cpfCnpj}`);

            if (response.data.length === 0) {
                alert('Fornecedor não encontrado');
                setForm(prev => ({
                    ...prev,
                    nomeFornecedor: ''
                }));
            } else {
                setTimeout(() => {
                    setForm(prev => ({
                        ...prev,
                        nomeFornecedor: response.data[0].NOME
                    }));
                }, 800);
                setFornecedorSelected(response.data[0].COD_FORNECEDOR);
            }
            setCarregandoFornecedor(false);
        } catch (err) {
            setCarregandoFornecedor(false);
            alert('Erro ao buscar fornecedor.');
        }
    };

    const handleContaCorrente = async () => {
        try {
            const retorno = await api.get(`/contacorrente/${instancia}`);
            if (retorno && retorno.status === 200) {
                setContaCorrente(retorno.data);
            }
        } catch (error) {
            alert(error);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
        setForm({
            banco: '',
            numero: '',
            valor: '',
            emissao: '',
            vencimento: '',
            status: 'PENDENTE',
            observacao: '',
            cpfCnpj: '',
            nomeFornecedor: '',
            cod_cheque: 0,
            codFornecedor: 0,
            codContaCorrente: 0
        });
        setContaSelecionada(0);
        setFornecedorSelected(0);
        handleContaCorrente();
        onClose();
    };

    const handleClose = () => {
        setContaSelecionada(0);
        setFornecedorSelected(0);
        setForm({
            banco: '',
            numero: '',
            valor: '',
            emissao: '',
            vencimento: '',
            status: 'PENDENTE',
            observacao: '',
            cpfCnpj: '',
            nomeFornecedor: '',
            cod_cheque: 0,
            codFornecedor: 0,
            codContaCorrente: 0
        });
        onClose();
    }

    const handleSelectContaCorrente = (id) => {
        const idConta = parseInt(id, 10);
        // Note que a sua API retorna { COD, DESCRICAO, BANCO, AGENCIA, NUMERO_CONTA }
        // então a busca deve ser feita usando COD
        const contaEncontrada = contaCorrente.find(conta => conta.COD === idConta);

        if (contaEncontrada) {
            setContaSelecionada(idConta);
            setForm(prev => ({
                ...prev,
                codContaCorrente: idConta,
                // CORRIGIDO: Usando os nomes das propriedades em maiúsculo
                banco: contaEncontrada.BANCO || '',
                agencia: contaEncontrada.AGENCIA || '',
                numero_conta: contaEncontrada.NUMERO_CONTA || '',
                numero: contaEncontrada.ULTUMO_CHEQUE_EMITIDO + 1
            }));
        } else {
            // Lógica para a opção "Todas" ou caso não encontre
            setContaSelecionada(0);
            setForm(prev => ({
                ...prev,
                codContaCorrente: 0,
                banco: '',
                agencia: '',
                numero_conta: '',
                numero: 0
            }));
        }
    }

    const handleSelectFornecedor = (id) => {
        if (id) {
            const fornecedor = fornecedores.find(f => f.COD_FORNECEDOR === parseInt(id));
            setFornecedorSelected(fornecedor.COD_FORNECEDOR);
            setForm(prev => ({
                ...prev,
                cpfCnpj: fornecedor.CNPJ_CPF,
                codFornecedor: fornecedor.COD_FORNECEDOR,
                nomeFornecedor: fornecedor.NOME
            }));
        } else {
            setFornecedorSelected(0)
            setForm(prev => ({
                ...prev,
                cpfCnpj: '',
                nomeFornecedor: '',
                codFornecedor: 0
            }));
        }
    }

    if (!isOpen) return null;

    return (
        <Overlay>
            <ModalContainer>
                <ModalHeader>{initialData ? 'Editar Cheque' : 'Novo Cheque'}</ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <InputGroup>
                            <Label>Conta Corrente:</Label>
                            <select
                                required
                                value={contaSelecionada}
                                onChange={(e) => handleSelectContaCorrente(e.target.value)}
                                style={{
                                    borderRadius: 10,
                                    height: 30,
                                    display: 'flex',
                                    textAlign: 'center',
                                    // border: 'none',
                                    fontSize: 16,
                                    marginTop: 10,
                                    color: '#000',
                                    width: 300,
                                    // backgroundColor: 'blueviolet',
                                }}
                            >
                                <option value="">Todas</option>
                                {contaCorrente.map((conta) => (
                                    <option key={conta.COD} value={conta.COD}>
                                        {conta.DESCRICAO}
                                    </option>
                                ))}
                            </select>
                        </InputGroup>
                    </Row>

                    <Row>
                        <InputGroup>
                            <Label>Banco</Label>
                            <Input
                                type="text"
                                name="banco"
                                value={form.banco}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Número do Cheque</Label>
                            <Input
                                type="text"
                                name="numero"
                                value={form.numero}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Valor</Label>
                            <Input
                                type="number"
                                step="0.01"
                                name="valor"
                                value={form.valor}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>
                    </Row>

                    {/* Data de Emissão e Vencimento */}
                    <Row>
                        <InputGroup>
                            <Label>Data de Emissão</Label>
                            <Input
                                type="date"
                                name="emissao"
                                value={form.emissao}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>

                        <InputGroup>
                            <Label>Data de Vencimento</Label>
                            <Input
                                type="date"
                                name="vencimento"
                                value={form.vencimento}
                                onChange={handleChange}
                                required
                            />
                        </InputGroup>
                    </Row>

                    <Row>

                        <InputGroup>
                            <Label>Fornecedor:</Label>
                            <select
                                required
                                value={fornecedorSelected}
                                onChange={(e) => handleSelectFornecedor(e.target.value)}
                                style={{
                                    borderRadius: 10,
                                    height: 30,
                                    display: 'flex',
                                    textAlign: 'center',
                                    // border: 'none',
                                    fontSize: 16,
                                    marginTop: 10,
                                    color: '#000',
                                    width: 300,
                                    // backgroundColor: 'blueviolet',
                                }}
                            >
                                <option value="">Todos</option>
                                {fornecedores.map((conta) => (
                                    <option key={conta.COD_FORNECEDOR} value={conta.COD_FORNECEDOR}>
                                        {conta.NOME}
                                    </option>
                                ))}
                            </select>
                        </InputGroup>

                        {/* CPF/CNPJ + Botão Buscar */}

                        <InputGroup>
                            <Label>CPF / CNPJ Fornecedor</Label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Input
                                    disabled
                                    type="text"
                                    name="cpfCnpj"
                                    value={form.cpfCnpj}
                                    onChange={handleChange}
                                    placeholder="000.000.000-00"
                                    maxLength="18"
                                    onInput={(e) => {
                                        let value = e.target.value.replace(/\D/g, '');

                                        if (value.length <= 11) {
                                            value = value.replace(/(\d{3})(\d)/, '$1.$2');
                                            value = value.replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
                                            value = value.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
                                        } else {
                                            value = value.replace(/^(\d{2})(\d)/, '$1.$2');
                                            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
                                            value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4');
                                            value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2}).*/, '$1.$2.$3/$4-$5');
                                        }
                                        e.target.value = value;
                                    }}
                                />
                            </div>
                        </InputGroup>

                    </Row>

                    <InputGroup>
                        <Label>Status</Label>
                        <Input
                            type="label"
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                            disabled
                        />
                    </InputGroup>

                    <InputGroup>
                        <Label>Observação (opcional)</Label>
                        <Input
                            as="textarea"
                            rows="3"
                            name="observacao"
                            value={form.observacao}
                            onChange={handleChange}
                        />
                    </InputGroup>

                    <ButtonGroup>
                        <CancelButton type="button" onClick={handleClose}>
                            Cancelar
                        </CancelButton>
                        <SaveButton type="submit">
                            {initialData ? 'Atualizar' : 'Salvar'}
                        </SaveButton>
                    </ButtonGroup>
                </Form>
            </ModalContainer>
        </Overlay>
    );
};

export default ChequePagarModal;